import { handleActions } from "redux-actions";
import { LOGIN_REQUEST, LOGIN_SUCCESS, SET_CSC, SET_SETTINGS, UPDATE_USER_AUTH } from "./types";
import { PAGES } from "../../pages";
import { getCurrencySymbol } from "../../services/utils";

export const DEMO_ACCOUNT_EMAIL = "James@carboonzero.com";
const TESTING_ACCOUNTS = ["gbates-roberts@mail.com", DEMO_ACCOUNT_EMAIL];
export const CLUSTER_REGISTRATION_FLOWS = [PAGES.demo.solar, PAGES.demo.default, PAGES.demo.hotels];

const initUser = {
  currency: {
    code: "USD",
    symbol: "$",
  },
};

const initState = {
  user: initUser,
  clusters: [],
  countries: [],
};

export default handleActions(
  {
    [LOGIN_REQUEST]: (state) => ({ ...state, user: initUser }),
    [LOGIN_SUCCESS]: (state, { payload }) => {
      const firstClusterRegistrationFlow = payload.user?.clusters?.[0]?.registration_flow
        ?.toLowerCase()
        .replaceAll(" ", "-");
      const userEmail = payload.user?.email;

      return {
        ...state,
        user: {
          ...payload.user,
          unit_system: payload.user?.unit_system?.toLowerCase() || "sqft",
          is_demo: userEmail === DEMO_ACCOUNT_EMAIL,
          is_testing: TESTING_ACCOUNTS.includes(userEmail),
          has_sqm_unit: payload.user?.unit_system?.toLowerCase() === "sqm",
          cluster_registration_flow:
            CLUSTER_REGISTRATION_FLOWS.includes(firstClusterRegistrationFlow) &&
            firstClusterRegistrationFlow,
          currency: {
            ...payload.user?.currency,
            symbol: getCurrencySymbol(payload.user?.currency?.code ?? "USD"),
          },
        },
        clusters: payload.user.clusters,
        countries: payload.user.countries,
      };
    },
    [SET_CSC]: (state, { payload }) => ({
      ...state,
      clusters: payload.clusters,
      countries: payload.countries,
    }),
    [SET_SETTINGS]: (state, { payload }) => ({
      ...state,
      user: {
        ...state.user,
        settings: payload,
      },
    }),
    [UPDATE_USER_AUTH]: (state, { payload }) => ({
      ...state,
      user: {
        ...state.user,
        unit_system: payload.user?.unit_system?.toLowerCase() || "sqft",
        has_sqm_unit: payload.user?.unit_system?.toLowerCase() === "sqm",
      },
    }),
  },
  initState
);
